<app-modal
  [(open)]="open"
  title="Confirm assignment"
  size="large"
  [primaryLabel]="isSubmitting() ? 'Assigning…' : 'Assign to ' + totalCount() + ' devices'"
  [primaryDisabled]="!acknowledged() || isSubmitting()"
  cancelLabel="Back to selection"
  (primaryAction)="submit()"
  (closed)="onClose()"
>
  <p class="text-[13px] text-ink-2">
    {{ update().name }} {{ update().version }} will be pushed to {{ totalCount() }} devices across
    {{ tenantCount() }} {{ tenantCount() === 1 ? 'tenant' : 'tenants' }}. Devices install at their next check-in.
  </p>

  <div class="mt-4 flex flex-col gap-2.5">
    @for (group of groups(); track group.tenantId) {
      <div
        class="flex items-center gap-3 rounded-card border border-hairline px-3.5 py-3"
        [style.box-shadow]="'inset 4px 0 0 ' + tenantDot(group.tenantId)"
      >
        <div class="text-[12.5px] font-semibold text-ink-1">{{ group.tenantName }}</div>
        <div class="ml-auto text-[13px] font-semibold text-ink-1">{{ group.clientIds.length }}</div>
      </div>
    }
  </div>

  <label class="mt-4 flex items-start gap-2.5">
    <input type="checkbox" class="mt-0.5" [checked]="acknowledged()" (change)="acknowledged.set(!acknowledged())" />
    <span class="text-[11.5px] text-ink-2">
      I understand this affects displays owned by {{ tenantCount() }} {{ tenantCount() === 1 ? 'tenant' : 'tenants' }}.
    </span>
  </label>
</app-modal>
